<template>
  <div>
    <el-container class="container">
      <el-header class="top-container">
        <div class="top-view">
          <!-- <span class="top-text" @click="toSignup" v-show="token.length==0">注册</span>
          <span class="top-divider" v-show="token.length==0">|</span> -->
          <span class="top-text" @click="toLogin" v-show="token.length==0">登录</span>

          <el-dropdown class="dropdown" v-show="token.length>0" @command='accountClick'>
            <div class="img-doctor-container">
              <img class="img-doctor" v-show="token.length>0" :src="userAvator"/>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="dropdown-item drop-first" command=''>
                <div class="user-contianer">
                  <span class="user-name">{{userName}}</span>
                  <span class="user-type">{{userTypeText}}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item class="dropdown-item drop-first" command='apply' v-show="!hasUserInfo || status == '3' || status == '4' || status == '5'">
                <div class="apply-contianer">
                  <span style="font-size: 16px;">医生认证</span>
                  <span class="status-text" v-if="statusText.length > 0">{{statusText}}</span>
                </div></el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='info' v-show='hasUserInfo'>个人信息</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='order'>我的订单</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='address'>我的地址</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='amount' v-if='showAmountInfo'>统一配送分账信息</el-dropdown-item>
              <!-- <el-dropdown-item class="dropdown-item" command='amount' v-show='false'>统一配送分账信息</el-dropdown-item> -->
              <el-dropdown-item class="dropdown-item" command='contact'>我的患者</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='occ' v-show='!isCommonUser'>后台管理</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command='logout'>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main style="width: 1366px;height: auto;">
        <div class="nav-container">
          <img class="logo" @click="reload" src="../../../static/image/logo.png" />
          <el-menu :default-active="activeIndex" class="el-menu" mode="horizontal" active-text-color="#156098"
            text-color="#333333" @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/Product">闻景产品</el-menu-item>
            <el-menu-item index="/Class">闻景课堂</el-menu-item>
            <el-menu-item index="/News">闻景新闻</el-menu-item>
            <el-menu-item index="/About">关于闻景</el-menu-item>
            <el-menu-item index="/Partner">合作共赢</el-menu-item>
            <el-menu-item index="/Read">有偿资讯</el-menu-item>
          </el-menu>
        </div>
        <keep-alive  :include="keepalive_components">
          <!-- <router-view class="sub-router-view" v-if="$route.meta.keepAlive"/> -->
          <router-view class="sub-router-view"/>
        </keep-alive>
        <!-- <router-view class="sub-router-view" v-if="!$route.meta.keepAlive" /> -->
        <Footer></Footer>
      </el-main>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px" center>
      <span class="dialog-content">确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="dialog-confirm" type="primary" :loading="oloading" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Footer from './Footer'
  import { EventBus } from "../../js/eventbus.js"
  export default {
    name:'Main',
    components: {
      Footer
    },
    data() {
      return {
        activeIndex: "/",
        dialogVisible: false,
        userName: '',
        oloading: false,
        token:'',
        userType:[],
        userTypeText:'',
        userAvator:'',
        userInfo:{},
        hasUserInfo:false,
        status:'',
        statusText:'',
        applyText:'医生认证',
        isCommonUser:true,
        showAmountInfo:false,
        keepalive_components:[]
      };
    },
    created() {
      console.log("main created")
      this.activeIndex = this.$route.path
      EventBus.$on("refresh", (msg) => {
        // home消息 刷新
        this.initInfo()
      });
      this.initInfo()
    },
    methods: {
      initInfo(){
        console.log("initInfo")
        var token = this.$cookies.get('token')
        var userInfo = this.$store.getters.getUserInfo
        console.log(userInfo)
        if(this.utils.isEmptyStr(token)){
          this.$store.commit('updateUserInfo',{})
          this.hasUserInfo = false
        }else{
          this.token = token
          this.axios.defaults.headers.common['Authorization'] = token
          this.axios.defaults.headers.common['appType'] = 'pc'
          this.axios.get('/api/getInfo',{params:{}})
          .then((res)=>{
              console.log(res)
              var data = res.data
              if(data.code == 200){
                this.$store.commit('updateUserInfo',data)
                var areaVersionId = data.areaVersionId
                var localAreaVersionId = this.$store.state.areaVersionId
                var areaInfo = this.$store.state.areaInfo
                var isAreaInfoValid = areaInfo && Array.isArray(areaInfo.province_list)
                console.log("areaVersionId:"+areaVersionId,"localAreaVersionId:" + localAreaVersionId, "isValid:", isAreaInfoValid)
                if(areaVersionId != localAreaVersionId || !isAreaInfoValid){
                    var instance = this.axios.create({
                        baseURL: this.axios.defaults.baseURL
                    });
                    instance.get('/api/system/area/list').then(res=>{
                      console.log(res)
                        if(res.data.code == 200){
                          var areas = res.data.data.area
                          var newAreaInfo = {
                              province_list: [],
                              city_list: [],
                              county_list: []
                          }
                          areas.forEach(areaData => {
                            if(areaData.level1){
                                areaData.level1.forEach(item => {
                                    newAreaInfo.province_list.push(item);
                                });
                            }
                            if(areaData.level2){
                                areaData.level2.forEach(item => {
                                    newAreaInfo.city_list.push(item);
                                });
                            }
                            if(areaData.level3){
                                areaData.level3.forEach(item => {
                                    newAreaInfo.county_list.push(item);
                                });
                            }
                          });
                          this.$store.commit('area',newAreaInfo)
                          this.$store.commit('updateAreaVersionId',res.data.data.versionId)
                          console.log(res.data.data.versionId)
                        }
                    })
                }
                this.userInfo = data
                this.setUserInfo(data)
              }else if(data.code == 401){
                this.token = ''
                this.$cookies.remove('token')
                sessionStorage.clear()
                this.$store.commit('updateUserInfo',{})
              }else {
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'获取账户异常，请联系管理员',
                    type:'error'
                })
                this.token = ''
                this.$cookies.remove('token')
                sessionStorage.clear()
                this.$store.commit('updateUserInfo',{})
              }
          }).catch((err)=>{
              console.log(err)
          })
        }
      },
      setUserInfo(userInfo){
        var doctor = userInfo.doctor
        if(!this.utils.isEmptyObject(doctor)){
          if(!this.utils.isEmptyStr(doctor.doctorName)){
            this.userName = doctor.doctorName
          }else{
            this.userName = userInfo.user.userName
          }
          this.hasUserInfo = true
          this.status = doctor.status
          console.log(this.status)
          if(this.status == '1'){
            this.statusText = '已停用'
          }else if(this.status == '2'){
            this.statusText = '邀请待确认'
          }else if(this.status == '3'){
            this.statusText = '资料待上传'
          }else if(this.status == '4'){
            this.statusText = '认证审核中'
          }else if(this.status == '5'){
            this.statusText = '认证审核失败'
          }
        }else{
          this.userName = userInfo.user.userName
          this.hasUserInfo = false
          this.userTypeText = "普通用户"
        }
        this.showAmountInfo = userInfo.settleInfo == 'Y'
        var roles = userInfo.roles
        if(!this.utils.isEmptyStr(roles)){
          if(this.isUserTypeByValue(roles,'superadmin')){
            this.isCommonUser = false
            this.userTypeText = '超级管理员'
            this.userAvator = require('../../../static/image/ic_admin.png')
          }else if(this.isUserTypeByValue(roles,'admin')){
            this.isCommonUser = false
            this.userTypeText = '管理员'
            this.userAvator = require('../../../static/image/ic_admin.png')
          }else if(this.isUserTypeByValue(roles,'level1')){
            this.isCommonUser = false
            this.userTypeText = '一级代理'
            this.userAvator = require('../../../static/image/ic_proxy.png')
          }else if(this.isUserTypeByValue(roles,'level2')){
            this.isCommonUser = false
            this.userTypeText = '二级代理'
            this.userAvator = require('../../../static/image/ic_proxy.png')
          }else if(this.isUserTypeByValue(roles,'hospital_admin')){
            this.isCommonUser = false
            this.userTypeText = '医院管理员'
            this.userAvator = require('../../../static/image/ic_admin.png')
          }else if(this.isUserTypeByValue(roles,'doctor') && this.status == '0'){
            this.isCommonUser = false
            this.userTypeText = '认证医生'
            this.userAvator = require('../../../static/image/ic_wjt_doctor.png')
          }else{
            this.isCommonUser = true
            this.userTypeText = '普通用户'
            this.userAvator = require('../../../static/image/ic_common_doctor.png')
          }
          console.log(roles)
          console.log(this.userTypeText)
          console.log(this.status)
        }else{
          this.isCommonUser = true
          this.userTypeText = '普通用户'
          this.userAvator = require('../../../static/image/ic_common_doctor.png')
        }
      },
      isUserTypeByValue(roles,val){
        for(var i=0;i<roles.length;i++){
          var value = roles[i]
          if(value == val){
            return true
          }
        }
        return false
      },
      handleSelect(index) {
          this.activeIndex = index
          this.$router.replace(index)
      },
      toLogin() {
        this.$router.push("/Login")
      },
      toSignup() {
        this.$router.push("/Signup")
      },
      dialogConfirm() {
        this.dialogVisible = false
        this.oloading = true
        this.wjtHttp.post(this, '/api/logout', {}, false, (res) => {
          this.oloading = false
          var data = res.data
          if (data.code == 200) {
            this.$message({
              message: '退出成功',
              type: 'success'
            })
            this.$cookies.remove("token")
            sessionStorage.clear()
            this.reload()
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '服务异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          this.oloading = false
        })
      },
      reload() {
        if(this.$route.path != '/'){
          this.$router.replace('/')
        }
        location.reload()
      },
      accountClick(command) {
        if(command == 'contact'){
          this.$router.push('/Contact')
        }else if(command == 'order'){
          this.$router.push('/order')
        }else if(command == 'address'){
          this.$router.push('/address')
        }else if(command == 'amount'){
          this.$router.push('/amount')
        }else if(command == 'apply'){
          if(this.utils.isEmptyObject(this.userInfo.doctor) || parseInt(this.userInfo.doctor.status) == 3){
            this.$router.push('/apply')
          }else{
            this.$router.push({path:'/applying',query:{status:this.userInfo.doctor.status,remark:this.userInfo.doctor.remark}})
          }
        }else if(command == 'info'){
          var info = {
            doctorName:this.userInfo.doctor.doctorName,
            doctorSex:this.userInfo.doctor.doctorSex,
            doctorPhonNo:this.userInfo.doctor.doctorPhonNo,
            idNo:this.userInfo.doctor.idNo,
            doctorCertNo:this.userInfo.doctor.doctorCertNo,
            doctorCertImageUrl:this.userInfo.doctor.doctorCertImageUrl
          }
          this.$router.push(
            {
              path:'/userInfo',
              query:{info:JSON.stringify(info)}
            }
          )
        }else if(command == 'logout'){
          this.dialogVisible = true
        }else if(command == 'occ'){
           window.open(process.env.DOMAIN_URL+'/occ', '_blank')
        }
      }
    }
  }
</script>

<style scoped>
  .container {
    height: 100%;
    display: flex;
    width: 1366px;
    flex-direction: column;
    align-items: center;
    background: white;
    overflow-y: hidden;
    overflow-x: scroll;
    margin: 0 auto;
  }

  .top-container {
    width: 1366px;
    height: 40px;
    background: #414141;
  }

  .top-view {
    max-width: 1160px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    position: relative;
    left: calc(50% - 625px);
    padding-right: 30px;
  }

  .dropdown {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .dropdown-item {
    font-size: 16px;
    color: #333333;
    width: 140px;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .drop-first{
    height: 70px;
    justify-content: flex-start;
    border-bottom-style: solid;
    border-width: 1px;
    border-color: #E6E6E6;
  }
  .top-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: white;
    cursor: pointer;
  }

  .top-divider {
    margin-left: 16px;
    margin-right: 16px;
    font-size: 16px;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .logo {
    width: 146px;
    font-size: 49px;
    color: #333333;
    cursor: pointer;
  }

  .nav-container {
    width: 1180px;
    height: 74px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: white;
    margin: auto auto;
  }

  .el-menu {
    background: transparent;
    margin-left: 114px;
  }

  .dialog-cancel {
    margin-right: 30px;
  }

  .dialog-confirm {
    margin-left: 30px;
  }

  .dialog-content {
    font-size: 16x;
  }
  .img-doctor-container{
    width: 45px;
    height: 45px;
    background-color: #156098;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }
  .sub-router-view{
    height: 100%;
    overflow: hidden;
  }
  .img-doctor{
    width: 28px;
    height: 28px;
  }
  .user-type{
    font-size: 14px;
    color: #999999;
    line-height: 30px;
  }
  .status-text{
    font-size: 13px;
    color: #156098;
    line-height: 30px;
  }
  .user-contianer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 70px;
  }
  .apply-contianer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 70px;
  }
  .user-name{
    line-height: 34px;
    font-size: 18px;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/Main.vue